<template>
  <component :is="way" />
</template>

<script>
  import { mapGetters } from 'vuex';
  import PROCESS_NAMES from '@/process/names';

  import Default from './default';
  const BkManager = () =>
    import(
      /* webpackChunkName: "bk-manager" */ '@/process/bk-manager/components/interview/landing/talentq/test/index.vue'
    );
  const Alrosa = () =>
    import(
      /* webpackChunkName: "alrosa" */ '@/process/alrosa/routes_new/outer/interview/landing/talentq/AlrosaTalentQ'
    );

  export default {
    name: 'TalentqTest',

    components: {
      Default,
      BkManager,
      Alrosa
    },

    computed: {
      ...mapGetters('process', ['getProcessName']),

      process() {
        return this.$store.getters['interview_talentq/process'] || this.getProcessName;
      },

      way() {
        const process = this.process;

        if (process === PROCESS_NAMES.BK_MANAGER || process === PROCESS_NAMES.ALROSA) {
          return process;
        } else {
          return 'default';
        }
      }
    }
  };
</script>
